import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisWorkflowDirecionamentoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/workflow-regra');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Workflow Direcionamento');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/workflow-regra', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Workflow Direcionamento');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/workflow-regra', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as  Workflow Direcionamento');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/workflow-regra/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a  Workflow Direcionamento');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/workflow-regra', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a  Workflow Direcionamento');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.api.post('/workflow-regra/delete/', body);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a  Workflow Direcionamento');
    }
  }
}
